import styled, { css } from 'styled-components';

export const PhaseDebugBadge = styled.div<{ $phase: string }>`
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 8px 20px;
  border-radius: 20px;
  font-family: 'Adam', 'Rajdhani', monospace;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.08em;
  backdrop-filter: blur(12px);
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;

  ${({ $phase }) => {
    switch ($phase) {
      case 'listening':
        return css`
          background: rgba(0, 200, 255, 0.2);
          border: 1px solid rgba(0, 200, 255, 0.6);
          color: #00c8ff;
          box-shadow: 0 0 16px rgba(0, 200, 255, 0.3);
        `;
      case 'thinking':
        return css`
          background: rgba(255, 170, 0, 0.2);
          border: 1px solid rgba(255, 170, 0, 0.6);
          color: #ffaa00;
          box-shadow: 0 0 16px rgba(255, 170, 0, 0.3);
        `;
      case 'speaking':
        return css`
          background: rgba(118, 185, 0, 0.2);
          border: 1px solid rgba(118, 185, 0, 0.6);
          color: #76b900;
          box-shadow: 0 0 16px rgba(118, 185, 0, 0.3);
        `;
      default:
        return css`
          background: rgba(255, 100, 100, 0.2);
          border: 1px solid rgba(255, 100, 100, 0.6);
          color: #ff6464;
          box-shadow: 0 0 16px rgba(255, 100, 100, 0.3);
        `;
    }
  }}
`;

export const PhaseDebugLog = styled.div`
  position: fixed;
  top: 52px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  pointer-events: none;
`;

export const PhaseDebugEntry = styled.div<{ $opacity: number }>`
  padding: 3px 12px;
  border-radius: 10px;
  font-family: monospace;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, ${({ $opacity }) => $opacity});
  backdrop-filter: blur(8px);
  white-space: nowrap;
  transition: opacity 0.3s ease;
`;
